const FALLBACK_PLANS = [
  {
    id: 'seedling',
    name: 'Starter',
    priceKey: 'plan_monthly_basic',
    priceLabel: '$9 / month',
    tokensLabel: '200 tokens / month',
    description: 'Perfect for getting started with AI-assisted tasks.',
    features: ['Monthly token refill', 'Unused tokens roll over', 'Cancel anytime'],
    ctaLabel: 'Get Starter'
  },
  {
    id: 'canopy',
    name: 'Pro',
    priceKey: 'plan_monthly_plus',
    priceLabel: '$19 / month',
    tokensLabel: '500 tokens / month',
    description: 'For regular users tackling complex projects.',
    features: ['Everything in Starter', 'Unlimited projects', '2.5× more tokens'],
    ctaLabel: 'Get Pro'
  },
  {
    id: 'grove',
    name: 'Max',
    priceKey: 'plan_monthly_pro',
    priceLabel: '$29 / month',
    tokensLabel: '1000 tokens / month',
    description: 'Maximum power for professionals and heavy usage.',
    features: ['Everything in Pro', 'Advanced models', 'Priority support'],
    ctaLabel: 'Get Max'
  }
];

const parseJson = (raw) => {
  if (!raw) return null;
  try {
    if (typeof raw === 'string') {
      return JSON.parse(raw);
    }
    if (Array.isArray(raw)) {
      return raw;
    }
  } catch (_) {
    return null;
  }
  return null;
};

const normalizePlan = (plan, index = 0) => {
  if (!plan) return null;
  const priceKey = String(plan.priceKey || plan.price_key || plan.id || '').trim();
  if (!priceKey) return null;
  const features = Array.isArray(plan.features) ? plan.features.filter(Boolean) : [];
  return {
    id: String(plan.id || plan.key || priceKey || `plan-${index}`),
    name: String(plan.name || plan.label || `Plan ${index + 1}`),
    priceKey,
    priceLabel: plan.priceLabel || plan.price || '',
    tokensLabel: plan.tokensLabel || plan.tokens || '',
    description: plan.description || '',
    features,
    ctaLabel: plan.ctaLabel || plan.cta || 'Select plan'
  };
};

const loadRuntimePlans = () => {
  try {
    if (typeof window !== 'undefined' && window.__OKIO_CONFIG__ && window.__OKIO_CONFIG__.subscriptionPlans) {
      return parseJson(window.__OKIO_CONFIG__.subscriptionPlans);
    }
  } catch (_) {
    return null;
  }
  const envRaw = process.env.REACT_APP_SUBSCRIPTION_PLANS;
  return parseJson(envRaw);
};

const resolvedPlans = (() => {
  const runtimePlans = loadRuntimePlans();
  if (Array.isArray(runtimePlans) && runtimePlans.length) {
    const normalized = runtimePlans
      .map((plan, idx) => normalizePlan(plan, idx))
      .filter(Boolean);
    if (normalized.length) return normalized;
  }
  return FALLBACK_PLANS;
})();

export const subscriptionPlans = resolvedPlans;

